import React from "react";
import classnames from "classnames";
import { navigate } from "gatsby";
import { Typography } from "@trussle/external-components";
import { trackEvent } from "../../../helpers/analytics";
import { IContentfulBackgroundColour } from "../../../types/IContentfulBackgroundColour";
import { IGridColumn } from "../../../types/IGridColumn";
import { GridColumn } from "../../GridColumn";
import "./styles.scss";
import { PanelWrapper } from "../../PanelWrapper";

export interface IGridPanelProps {
  title?: string;
  bgColour: IContentfulBackgroundColour | "green";
  gridColumns: IGridColumn[];
  headerAnchor?: string;
  betterV2?: boolean;
}

const backgroundColorsWithWhiteColumns = [
  "lime-green",
  "sky-blue",
  "green",
  "pink",
  "light-grey",
  "grey",
];

export const GridPanel = (props: IGridPanelProps) => {
  const {
    bgColour,
    gridColumns,
    title,
    headerAnchor,
  } = props;
  const whiteColumns = backgroundColorsWithWhiteColumns.includes(bgColour);

  const columnClassName = classnames("gridPanel__column", {
    "gridPanel--column-background-blue": !whiteColumns,
    "gridPanel--column-background-white": whiteColumns,
  });

  return (
    <PanelWrapper
      backgroundColour={props.betterV2 ? "light-yellow" : bgColour}
      isBetterV2={props.betterV2}
    >
      <section
        className={classnames("gridPanel", {
          "gridPanel-betterV2": props.betterV2,
        })}
        id={headerAnchor}
      >
        <Typography
          variant="h2"
          classes="gridPanel_header"
        >
          {title}
        </Typography>
        <div className="gridPanel_columnContainer">
          {gridColumns.map((column, index) => (
            <GridColumn
              key={index}
              classNames={columnClassName}
              title={column.title}
              url={column.url}
              headingType={column.headingType}
              description={column.description}
              gridText={column.gridText}
              betterV2={props.betterV2}
              handleClick={(e) => {
                e.preventDefault();
                trackEvent(`Buyer profile - header - ${column.title}`);
                navigate(column.url);
              }}
            />
          ))}
        </div>
      </section>
    </PanelWrapper>
  );
};
